import type { Component } from "solid-js";
import type { IconProps } from "./types";

const HybridKnowledgeIcon: Component<IconProps> = (props = {}) => {
  const size = props.size || 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      {/* Half Earth */}
      <path
        d="M10 1 C 7 1 4 2.5 2.5 5 C 1 7 0.5 9 0.5 11 C 0.5 14.5 4 19 10 19 L 10 1 Z"
        fill="none"
        stroke="currentColor"
        stroke-width="0.5"
      />

      {/* Simplified Continent on half-earth */}
      <path
        d="M3 6 Q4 5 6 5.5 Q7.5 5 10 6 L10 10 Q7.5 9.5 6 8.5 Q4.5 9.5 3.5 8.5 Q3.5 7 3 6"
        fill="currentColor"
        opacity="0.2"
      />
      <path
        d="M2.5 11 Q3 12 4.5 12.5 Q5.5 13.5 6.5 13 Q7 14 10 13.5 L10 19 Q7.5 18.5 5 17.5 Q2.5 15 2 12.5 Q2 11.5 2.5 11"
        fill="currentColor"
        opacity="0.2"
      />

      {/* Earth details */}
      <ellipse cx="5" cy="10" rx="4.5" ry="2" fill="none" stroke="currentColor" stroke-width="0.3" opacity="0.5" />
      <line x1="0.5" y1="10" x2="10" y2="10" stroke="currentColor" stroke-width="0.3" opacity="0.5" />

      {/* Half Files Stack */}
      <path d="M10 1 L17 1 L19.5 3.5 L19.5 19 L10 19 Z" fill="none" stroke="currentColor" stroke-width="0.5" />

      {/* File details */}
      <path d="M11 3 L15 3 L17 5 L17 9 L11 9 Z" fill="none" stroke="currentColor" stroke-width="0.4" />
      <path d="M11.5 5 L14.5 5" stroke="currentColor" stroke-width="0.3" />
      <path d="M11.5 6 L15.5 6" stroke="currentColor" stroke-width="0.3" />
      <path d="M11.5 7 L15.5 7" stroke="currentColor" stroke-width="0.3" />

      <path d="M12 11 L16 11 L18 13 L18 17 L12 17 Z" fill="none" stroke="currentColor" stroke-width="0.4" />
      <path d="M12.5 13 L15.5 13" stroke="currentColor" stroke-width="0.3" />
      <path d="M12.5 14 L16.5 14" stroke="currentColor" stroke-width="0.3" />
      <path d="M12.5 15 L16.5 15" stroke="currentColor" stroke-width="0.3" />
    </svg>
  );
};

export default HybridKnowledgeIcon;
